import { Navigation, Hourglass, Bell, Radio } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";

const LIVE_FEATURES = [
  {
    id: "location",
    icon: Navigation,
    title: "Posizione in tempo reale",
    desc: "Localizza il dispositivo di famiglia sulla mappa con aggiornamento continuo della posizione GPS e cronologia.",
    tag: "GPS live",
  },
  {
    id: "usage",
    icon: Hourglass,
    title: "Tempo di utilizzo",
    desc: "Monitora quanto tempo i tuoi figli passano sulle app e favorisci abitudini digitali sane, in modo trasparente.",
    tag: "Benessere digitale",
  },
  {
    id: "geofence",
    icon: Bell,
    title: "Avvisi geofence",
    desc: "Ricevi una notifica automatica quando tuo figlio arriva o lascia un luogo importante, come la scuola o casa.",
    tag: "Avvisi in tempo reale",
  },
];

export const LiveFeatures = () => {
  return (
    <section id="funzioni-in-diretta" className="section-tint py-14 sm:py-20" data-testid="live-features-section">
      <div className="container-x">
        <Reveal>
          <div className="flex flex-col items-start gap-3">
            <span className="inline-flex items-center gap-2 rounded-full border border-[hsl(var(--live)/0.4)] bg-[hsl(var(--live)/0.08)] px-3 py-1 text-xs font-semibold text-[hsl(var(--live))]">
              <span className="relative flex h-2 w-2">
                <span className="live-dot absolute inline-flex h-full w-full rounded-full bg-[hsl(var(--live))]" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-[hsl(var(--live))]" />
              </span>
              IN DIRETTA
            </span>
            <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight">Funzioni in diretta</h2>
            <p className="max-w-2xl text-muted-foreground leading-relaxed">
              Sicurezza della famiglia in tempo reale: posizione, tempo di utilizzo e avvisi automatici,
              direttamente dal tuo pannello e sempre in modo trasparente.
            </p>
          </div>
        </Reveal>

        <StaggerGroup className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
          {LIVE_FEATURES.map((f) => (
            <StaggerItem key={f.id}>
              <div
                data-testid={`live-feature-${f.id}`}
                className="live-aura relative overflow-hidden rounded-2xl border border-border bg-card p-6 day-card-shadow dark:glow card-lift before:absolute before:inset-x-0 before:top-0 before:h-[3px] before:bg-accent"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent/10 text-accent glow">
                    <f.icon className="h-6 w-6" />
                  </span>
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-[hsl(var(--live)/0.10)] px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-[hsl(var(--live))]">
                    <span className="relative flex h-1.5 w-1.5">
                      <span className="live-dot absolute inline-flex h-full w-full rounded-full bg-[hsl(var(--live))]" />
                      <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[hsl(var(--live))]" />
                    </span>
                    Live
                  </span>
                </div>
                <h3 className="mt-5 text-lg font-semibold">{f.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{f.desc}</p>
                <div className="mt-5 flex items-center gap-2 text-xs font-medium text-accent">
                  <Radio className="h-3.5 w-3.5" /> {f.tag}
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
